import devFeatureFlags from '../constants/feature-flags-dev.json'
import stagingFeatureFlags from '../constants/feature-flags-staging.json'
import prodFeatureFlags from '../constants/feature-flags-prod.json'
import defaultFeatureFlags from '../constants/feature-flags-default.json'
import { environmentConstants } from '../constants/environment-constants'

export const getFeatureFlags = () => {
  const env = import.meta.env.VITE_ENV
  switch (env) {
    case environmentConstants.DEVELOPMENT:
      return devFeatureFlags
    case environmentConstants.STAGING:
      return stagingFeatureFlags
    case environmentConstants.PRODUCTION:
      return prodFeatureFlags
    default:
      /* All feature flags are turned off */
      return defaultFeatureFlags
  }
}
